var _rect, _path, _rect2, _path2, _rect3, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.51245,
    width: 24.1662,
    height: 24.1662,
    rx: 3.62493,
    transform: "rotate(13.1855 5.51245 0)",
    fill: "url(#paint0_linear_899_14)",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6548 13.8616L18.4402 14.5142L12.155 20.4391L13.3871 15.1797L10.6017 14.5271L16.8869 8.60225L15.6548 13.8616Z",
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.158447,
    y: 5.31445,
    width: 24.1662,
    height: 24.1662,
    rx: 3.62493,
    transform: "rotate(-12.3207 0.158447 5.31445)",
    fill: "url(#paint1_linear_899_14)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2811 13.4582L18.076 12.8478L14.9547 20.9017L13.802 15.6243L11.0071 16.2347L14.1284 8.18083L15.2811 13.4582Z",
    fill: "#F5F5F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.41699,
    y: 2.41602,
    width: 24.1662,
    height: 24.1662,
    rx: 3.62493,
    fill: "url(#paint2_linear_899_14)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9695 11.5489V13.1113C15.2967 12.6129 15.7477 12.208 16.2783 11.9363C16.8089 11.6645 17.401 11.5352 17.9967 11.5609C21.1775 11.5609 21.8653 13.5495 21.8653 16.1366V21.4038H18.9192V16.7341C18.9192 15.6201 18.6945 14.1876 16.96 14.1876C15.2779 14.1876 14.9907 15.4001 14.9907 16.6513V21.4038H12.0538V11.5489H14.9695ZM10.0808 9.07234C10.0804 9.36419 9.99394 9.64945 9.83212 9.89234C9.67031 10.1352 9.44039 10.3249 9.1712 10.4377C8.90211 10.5495 8.60584 10.5788 8.32008 10.5217C8.03432 10.4647 7.77199 10.3239 7.56648 10.1173C7.36059 9.91057 7.22042 9.64758 7.1636 9.3614C7.10677 9.07522 7.13583 8.77863 7.24712 8.50892C7.3584 8.23921 7.54695 8.00842 7.78905 7.84559C8.03115 7.68275 8.31599 7.59513 8.60775 7.59375C8.80166 7.59375 8.99367 7.63203 9.17275 7.70641C9.35183 7.78078 9.51446 7.88978 9.65132 8.02715C9.78818 8.16452 9.89657 8.32757 9.97027 8.50693C10.044 8.68628 10.0815 8.87843 10.0808 9.07234Z",
    fill: "#F0EDE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0806 11.5609H7.13452V21.4037H10.0806V11.5609Z",
    fill: "#F0EDE6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_899_14",
    x1: 5.51245,
    y1: 0,
    x2: 30.0834,
    y2: 0.418806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA75F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_899_14",
    x1: 0.158447,
    y1: 5.31445,
    x2: 24.7294,
    y2: 5.73326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA75F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_899_14",
    x1: 2.41699,
    y1: 2.41602,
    x2: 26.988,
    y2: 2.83482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E6EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA75F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.743fe99551f326f53bdef91d1cc182b3.svg";
export { ForwardRef as ReactComponent };